import { z } from 'zod';

import { CoercedEscrowInsuranceType } from '../../../loan/EscrowSetting';
import { OptionalPhoneNumber } from '../../../Phone';
import { OptionalEmailString } from '../../email';
import { AddressLine, Checkbox, DateString, NonNegativeMonetaryValue } from '../../fields';

export const DeprecatedInsuranceFields = z.object({
  insurance1Type: CoercedEscrowInsuranceType.optional(),
  insurance1IsEscrowed: Checkbox.optional(),
  insurance1Amount: NonNegativeMonetaryValue.optional(),
  insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  insurance1AgentName: z.string().optional(),
  insurance1AgentEmail: OptionalEmailString,
  insurance1AgentPhone: OptionalPhoneNumber,
  insurance1CompanyName: z.string().optional(),
  insurance1CompanyAddressLine1: AddressLine.optional(),
  insurance1CompanyAddressLine2: AddressLine.optional(),
  insurance1CompanyAddressCity: z.string().optional(),
  insurance1CompanyAddressState: z.string().optional(),
  insurance1CompanyAddressZip: z.string().optional(),
  insurance1PolicyNumber: z.string().optional(),
  insurance1PolicyStart: DateString.optional(),
  insurance1PolicyEnd: DateString.optional(),
  insurance1ForcedPlacedFlag: Checkbox.optional(),

  insurance2Type: CoercedEscrowInsuranceType.optional(),
  insurance2IsEscrowed: Checkbox.optional(),
  insurance2Amount: NonNegativeMonetaryValue.optional(),
  insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  insurance2AgentName: z.string().optional(),
  insurance2AgentEmail: OptionalEmailString,
  insurance2AgentPhone: OptionalPhoneNumber,
  insurance2CompanyName: z.string().optional(),
  insurance2CompanyAddressLine1: AddressLine.optional(),
  insurance2CompanyAddressLine2: AddressLine.optional(),
  insurance2CompanyAddressCity: z.string().optional(),
  insurance2CompanyAddressState: z.string().optional(),
  insurance2CompanyAddressZip: z.string().optional(),
  insurance2PolicyNumber: z.string().optional(),
  insurance2PolicyStart: DateString.optional(),
  insurance2PolicyEnd: DateString.optional(),
  insurance2ForcedPlacedFlag: Checkbox.optional(),

  insurance3Type: CoercedEscrowInsuranceType.optional(),
  insurance3IsEscrowed: Checkbox.optional(),
  insurance3Amount: NonNegativeMonetaryValue.optional(),
  insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  insurance3AgentName: z.string().optional(),
  insurance3AgentEmail: OptionalEmailString,
  insurance3AgentPhone: OptionalPhoneNumber,
  insurance3CompanyName: z.string().optional(),
  insurance3CompanyAddressLine1: AddressLine.optional(),
  insurance3CompanyAddressLine2: AddressLine.optional(),
  insurance3CompanyAddressCity: z.string().optional(),
  insurance3CompanyAddressState: z.string().optional(),
  insurance3CompanyAddressZip: z.string().optional(),
  insurance3PolicyNumber: z.string().optional(),
  insurance3PolicyStart: DateString.optional(),
  insurance3PolicyEnd: DateString.optional(),
  insurance3ForcedPlacedFlag: Checkbox.optional(),

  insurance4Type: CoercedEscrowInsuranceType.optional(),
  insurance4IsEscrowed: Checkbox.optional(),
  insurance4Amount: NonNegativeMonetaryValue.optional(),
  insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  insurance4AgentName: z.string().optional(),
  insurance4AgentEmail: OptionalEmailString,
  insurance4AgentPhone: OptionalPhoneNumber,
  insurance4CompanyName: z.string().optional(),
  insurance4CompanyAddressLine1: AddressLine.optional(),
  insurance4CompanyAddressLine2: AddressLine.optional(),
  insurance4CompanyAddressCity: z.string().optional(),
  insurance4CompanyAddressState: z.string().optional(),
  insurance4CompanyAddressZip: z.string().optional(),
  insurance4PolicyNumber: z.string().optional(),
  insurance4PolicyStart: DateString.optional(),
  insurance4PolicyEnd: DateString.optional(),
  insurance4ForcedPlacedFlag: Checkbox.optional(),

  insurance5Type: CoercedEscrowInsuranceType.optional(),
  insurance5IsEscrowed: Checkbox.optional(),
  insurance5Amount: NonNegativeMonetaryValue.optional(),
  insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  insurance5AgentName: z.string().optional(),
  insurance5AgentEmail: OptionalEmailString,
  insurance5AgentPhone: OptionalPhoneNumber,
  insurance5CompanyName: z.string().optional(),
  insurance5CompanyAddressLine1: AddressLine.optional(),
  insurance5CompanyAddressLine2: AddressLine.optional(),
  insurance5CompanyAddressCity: z.string().optional(),
  insurance5CompanyAddressState: z.string().optional(),
  insurance5CompanyAddressZip: z.string().optional(),
  insurance5PolicyNumber: z.string().optional(),
  insurance5PolicyStart: DateString.optional(),
  insurance5PolicyEnd: DateString.optional(),
  insurance5ForcedPlacedFlag: Checkbox.optional(),

  insurance6Type: CoercedEscrowInsuranceType.optional(),
  insurance6IsEscrowed: Checkbox.optional(),
  insurance6Amount: NonNegativeMonetaryValue.optional(),
  insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  insurance6AgentName: z.string().optional(),
  insurance6AgentEmail: OptionalEmailString,
  insurance6AgentPhone: OptionalPhoneNumber,
  insurance6CompanyName: z.string().optional(),
  insurance6CompanyAddressLine1: AddressLine.optional(),
  insurance6CompanyAddressLine2: AddressLine.optional(),
  insurance6CompanyAddressCity: z.string().optional(),
  insurance6CompanyAddressState: z.string().optional(),
  insurance6CompanyAddressZip: z.string().optional(),
  insurance6PolicyNumber: z.string().optional(),
  insurance6PolicyStart: DateString.optional(),
  insurance6PolicyEnd: DateString.optional(),
  insurance6ForcedPlacedFlag: Checkbox.optional(),
});

export const DeprecatedMultipleAddressesInsuranceFields = z.object({
  // ADDRESS 2
  address2Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address2Insurance1IsEscrowed: Checkbox.optional(),
  address2Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address2Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address2Insurance1AgentName: z.string().optional(),
  address2Insurance1AgentEmail: OptionalEmailString,
  address2Insurance1AgentPhone: OptionalPhoneNumber,
  address2Insurance1CompanyName: z.string().optional(),
  address2Insurance1CompanyAddressLine1: AddressLine.optional(),
  address2Insurance1CompanyAddressLine2: AddressLine.optional(),
  address2Insurance1CompanyAddressCity: z.string().optional(),
  address2Insurance1CompanyAddressState: z.string().optional(),
  address2Insurance1CompanyAddressZip: z.string().optional(),
  address2Insurance1PolicyNumber: z.string().optional(),
  address2Insurance1PolicyStart: DateString.optional(),
  address2Insurance1PolicyEnd: DateString.optional(),
  address2Insurance1ForcedPlacedFlag: Checkbox.optional(),

  address2Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address2Insurance2IsEscrowed: Checkbox.optional(),
  address2Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address2Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address2Insurance2AgentName: z.string().optional(),
  address2Insurance2AgentEmail: OptionalEmailString,
  address2Insurance2AgentPhone: OptionalPhoneNumber,
  address2Insurance2CompanyName: z.string().optional(),
  address2Insurance2CompanyAddressLine1: AddressLine.optional(),
  address2Insurance2CompanyAddressLine2: AddressLine.optional(),
  address2Insurance2CompanyAddressCity: z.string().optional(),
  address2Insurance2CompanyAddressState: z.string().optional(),
  address2Insurance2CompanyAddressZip: z.string().optional(),
  address2Insurance2PolicyNumber: z.string().optional(),
  address2Insurance2PolicyStart: DateString.optional(),
  address2Insurance2PolicyEnd: DateString.optional(),
  address2Insurance2ForcedPlacedFlag: Checkbox.optional(),

  address2Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address2Insurance3IsEscrowed: Checkbox.optional(),
  address2Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address2Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address2Insurance3AgentName: z.string().optional(),
  address2Insurance3AgentEmail: OptionalEmailString,
  address2Insurance3AgentPhone: OptionalPhoneNumber,
  address2Insurance3CompanyName: z.string().optional(),
  address2Insurance3CompanyAddressLine1: AddressLine.optional(),
  address2Insurance3CompanyAddressLine2: AddressLine.optional(),
  address2Insurance3CompanyAddressCity: z.string().optional(),
  address2Insurance3CompanyAddressState: z.string().optional(),
  address2Insurance3CompanyAddressZip: z.string().optional(),
  address2Insurance3PolicyNumber: z.string().optional(),
  address2Insurance3PolicyStart: DateString.optional(),
  address2Insurance3PolicyEnd: DateString.optional(),
  address2Insurance3ForcedPlacedFlag: Checkbox.optional(),

  address2Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address2Insurance4IsEscrowed: Checkbox.optional(),
  address2Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address2Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address2Insurance4AgentName: z.string().optional(),
  address2Insurance4AgentEmail: OptionalEmailString,
  address2Insurance4AgentPhone: OptionalPhoneNumber,
  address2Insurance4CompanyName: z.string().optional(),
  address2Insurance4CompanyAddressLine1: AddressLine.optional(),
  address2Insurance4CompanyAddressLine2: AddressLine.optional(),
  address2Insurance4CompanyAddressCity: z.string().optional(),
  address2Insurance4CompanyAddressState: z.string().optional(),
  address2Insurance4CompanyAddressZip: z.string().optional(),
  address2Insurance4PolicyNumber: z.string().optional(),
  address2Insurance4PolicyStart: DateString.optional(),
  address2Insurance4PolicyEnd: DateString.optional(),
  address2Insurance4ForcedPlacedFlag: Checkbox.optional(),

  address2Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address2Insurance5IsEscrowed: Checkbox.optional(),
  address2Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address2Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address2Insurance5AgentName: z.string().optional(),
  address2Insurance5AgentEmail: OptionalEmailString,
  address2Insurance5AgentPhone: OptionalPhoneNumber,
  address2Insurance5CompanyName: z.string().optional(),
  address2Insurance5CompanyAddressLine1: AddressLine.optional(),
  address2Insurance5CompanyAddressLine2: AddressLine.optional(),
  address2Insurance5CompanyAddressCity: z.string().optional(),
  address2Insurance5CompanyAddressState: z.string().optional(),
  address2Insurance5CompanyAddressZip: z.string().optional(),
  address2Insurance5PolicyNumber: z.string().optional(),
  address2Insurance5PolicyStart: DateString.optional(),
  address2Insurance5PolicyEnd: DateString.optional(),
  address2Insurance5ForcedPlacedFlag: Checkbox.optional(),

  address2Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address2Insurance6IsEscrowed: Checkbox.optional(),
  address2Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address2Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address2Insurance6AgentName: z.string().optional(),
  address2Insurance6AgentEmail: OptionalEmailString,
  address2Insurance6AgentPhone: OptionalPhoneNumber,
  address2Insurance6CompanyName: z.string().optional(),
  address2Insurance6CompanyAddressLine1: AddressLine.optional(),
  address2Insurance6CompanyAddressLine2: AddressLine.optional(),
  address2Insurance6CompanyAddressCity: z.string().optional(),
  address2Insurance6CompanyAddressState: z.string().optional(),
  address2Insurance6CompanyAddressZip: z.string().optional(),
  address2Insurance6PolicyNumber: z.string().optional(),
  address2Insurance6PolicyStart: DateString.optional(),
  address2Insurance6PolicyEnd: DateString.optional(),
  address2Insurance6ForcedPlacedFlag: Checkbox.optional(),

  // ADDRESS 3
  address3Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address3Insurance1IsEscrowed: Checkbox.optional(),
  address3Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address3Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address3Insurance1AgentName: z.string().optional(),
  address3Insurance1AgentEmail: OptionalEmailString,
  address3Insurance1AgentPhone: OptionalPhoneNumber,
  address3Insurance1CompanyName: z.string().optional(),
  address3Insurance1CompanyAddressLine1: AddressLine.optional(),
  address3Insurance1CompanyAddressLine2: AddressLine.optional(),
  address3Insurance1CompanyAddressCity: z.string().optional(),
  address3Insurance1CompanyAddressState: z.string().optional(),
  address3Insurance1CompanyAddressZip: z.string().optional(),
  address3Insurance1PolicyNumber: z.string().optional(),
  address3Insurance1PolicyStart: DateString.optional(),
  address3Insurance1PolicyEnd: DateString.optional(),
  address3Insurance1ForcedPlacedFlag: Checkbox.optional(),

  address3Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address3Insurance2IsEscrowed: Checkbox.optional(),
  address3Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address3Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address3Insurance2AgentName: z.string().optional(),
  address3Insurance2AgentEmail: OptionalEmailString,
  address3Insurance2AgentPhone: OptionalPhoneNumber,
  address3Insurance2CompanyName: z.string().optional(),
  address3Insurance2CompanyAddressLine1: AddressLine.optional(),
  address3Insurance2CompanyAddressLine2: AddressLine.optional(),
  address3Insurance2CompanyAddressCity: z.string().optional(),
  address3Insurance2CompanyAddressState: z.string().optional(),
  address3Insurance2CompanyAddressZip: z.string().optional(),
  address3Insurance2PolicyNumber: z.string().optional(),
  address3Insurance2PolicyStart: DateString.optional(),
  address3Insurance2PolicyEnd: DateString.optional(),
  address3Insurance2ForcedPlacedFlag: Checkbox.optional(),

  address3Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address3Insurance3IsEscrowed: Checkbox.optional(),
  address3Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address3Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address3Insurance3AgentName: z.string().optional(),
  address3Insurance3AgentEmail: OptionalEmailString,
  address3Insurance3AgentPhone: OptionalPhoneNumber,
  address3Insurance3CompanyName: z.string().optional(),
  address3Insurance3CompanyAddressLine1: AddressLine.optional(),
  address3Insurance3CompanyAddressLine2: AddressLine.optional(),
  address3Insurance3CompanyAddressCity: z.string().optional(),
  address3Insurance3CompanyAddressState: z.string().optional(),
  address3Insurance3CompanyAddressZip: z.string().optional(),
  address3Insurance3PolicyNumber: z.string().optional(),
  address3Insurance3PolicyStart: DateString.optional(),
  address3Insurance3PolicyEnd: DateString.optional(),
  address3Insurance3ForcedPlacedFlag: Checkbox.optional(),

  address3Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address3Insurance4IsEscrowed: Checkbox.optional(),
  address3Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address3Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address3Insurance4AgentName: z.string().optional(),
  address3Insurance4AgentEmail: OptionalEmailString,
  address3Insurance4AgentPhone: OptionalPhoneNumber,
  address3Insurance4CompanyName: z.string().optional(),
  address3Insurance4CompanyAddressLine1: AddressLine.optional(),
  address3Insurance4CompanyAddressLine2: AddressLine.optional(),
  address3Insurance4CompanyAddressCity: z.string().optional(),
  address3Insurance4CompanyAddressState: z.string().optional(),
  address3Insurance4CompanyAddressZip: z.string().optional(),
  address3Insurance4PolicyNumber: z.string().optional(),
  address3Insurance4PolicyStart: DateString.optional(),
  address3Insurance4PolicyEnd: DateString.optional(),
  address3Insurance4ForcedPlacedFlag: Checkbox.optional(),

  address3Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address3Insurance5IsEscrowed: Checkbox.optional(),
  address3Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address3Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address3Insurance5AgentName: z.string().optional(),
  address3Insurance5AgentEmail: OptionalEmailString,
  address3Insurance5AgentPhone: OptionalPhoneNumber,
  address3Insurance5CompanyName: z.string().optional(),
  address3Insurance5CompanyAddressLine1: AddressLine.optional(),
  address3Insurance5CompanyAddressLine2: AddressLine.optional(),
  address3Insurance5CompanyAddressCity: z.string().optional(),
  address3Insurance5CompanyAddressState: z.string().optional(),
  address3Insurance5CompanyAddressZip: z.string().optional(),
  address3Insurance5PolicyNumber: z.string().optional(),
  address3Insurance5PolicyStart: DateString.optional(),
  address3Insurance5PolicyEnd: DateString.optional(),
  address3Insurance5ForcedPlacedFlag: Checkbox.optional(),

  address3Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address3Insurance6IsEscrowed: Checkbox.optional(),
  address3Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address3Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address3Insurance6AgentName: z.string().optional(),
  address3Insurance6AgentEmail: OptionalEmailString,
  address3Insurance6AgentPhone: OptionalPhoneNumber,
  address3Insurance6CompanyName: z.string().optional(),
  address3Insurance6CompanyAddressLine1: AddressLine.optional(),
  address3Insurance6CompanyAddressLine2: AddressLine.optional(),
  address3Insurance6CompanyAddressCity: z.string().optional(),
  address3Insurance6CompanyAddressState: z.string().optional(),
  address3Insurance6CompanyAddressZip: z.string().optional(),
  address3Insurance6PolicyNumber: z.string().optional(),
  address3Insurance6PolicyStart: DateString.optional(),
  address3Insurance6PolicyEnd: DateString.optional(),
  address3Insurance6ForcedPlacedFlag: Checkbox.optional(),

  // ADDRESS 4
  address4Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address4Insurance1IsEscrowed: Checkbox.optional(),
  address4Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address4Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address4Insurance1AgentName: z.string().optional(),
  address4Insurance1AgentEmail: OptionalEmailString,
  address4Insurance1AgentPhone: OptionalPhoneNumber,
  address4Insurance1CompanyName: z.string().optional(),
  address4Insurance1CompanyAddressLine1: AddressLine.optional(),
  address4Insurance1CompanyAddressLine2: AddressLine.optional(),
  address4Insurance1CompanyAddressCity: z.string().optional(),
  address4Insurance1CompanyAddressState: z.string().optional(),
  address4Insurance1CompanyAddressZip: z.string().optional(),
  address4Insurance1PolicyNumber: z.string().optional(),
  address4Insurance1PolicyStart: DateString.optional(),
  address4Insurance1PolicyEnd: DateString.optional(),
  address4Insurance1ForcedPlacedFlag: Checkbox.optional(),

  address4Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address4Insurance2IsEscrowed: Checkbox.optional(),
  address4Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address4Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address4Insurance2AgentName: z.string().optional(),
  address4Insurance2AgentEmail: OptionalEmailString,
  address4Insurance2AgentPhone: OptionalPhoneNumber,
  address4Insurance2CompanyName: z.string().optional(),
  address4Insurance2CompanyAddressLine1: AddressLine.optional(),
  address4Insurance2CompanyAddressLine2: AddressLine.optional(),
  address4Insurance2CompanyAddressCity: z.string().optional(),
  address4Insurance2CompanyAddressState: z.string().optional(),
  address4Insurance2CompanyAddressZip: z.string().optional(),
  address4Insurance2PolicyNumber: z.string().optional(),
  address4Insurance2PolicyStart: DateString.optional(),
  address4Insurance2PolicyEnd: DateString.optional(),
  address4Insurance2ForcedPlacedFlag: Checkbox.optional(),

  address4Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address4Insurance3IsEscrowed: Checkbox.optional(),
  address4Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address4Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address4Insurance3AgentName: z.string().optional(),
  address4Insurance3AgentEmail: OptionalEmailString,
  address4Insurance3AgentPhone: OptionalPhoneNumber,
  address4Insurance3CompanyName: z.string().optional(),
  address4Insurance3CompanyAddressLine1: AddressLine.optional(),
  address4Insurance3CompanyAddressLine2: AddressLine.optional(),
  address4Insurance3CompanyAddressCity: z.string().optional(),
  address4Insurance3CompanyAddressState: z.string().optional(),
  address4Insurance3CompanyAddressZip: z.string().optional(),
  address4Insurance3PolicyNumber: z.string().optional(),
  address4Insurance3PolicyStart: DateString.optional(),
  address4Insurance3PolicyEnd: DateString.optional(),
  address4Insurance3ForcedPlacedFlag: Checkbox.optional(),

  address4Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address4Insurance4IsEscrowed: Checkbox.optional(),
  address4Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address4Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address4Insurance4AgentName: z.string().optional(),
  address4Insurance4AgentEmail: OptionalEmailString,
  address4Insurance4AgentPhone: OptionalPhoneNumber,
  address4Insurance4CompanyName: z.string().optional(),
  address4Insurance4CompanyAddressLine1: AddressLine.optional(),
  address4Insurance4CompanyAddressLine2: AddressLine.optional(),
  address4Insurance4CompanyAddressCity: z.string().optional(),
  address4Insurance4CompanyAddressState: z.string().optional(),
  address4Insurance4CompanyAddressZip: z.string().optional(),
  address4Insurance4PolicyNumber: z.string().optional(),
  address4Insurance4PolicyStart: DateString.optional(),
  address4Insurance4PolicyEnd: DateString.optional(),
  address4Insurance4ForcedPlacedFlag: Checkbox.optional(),

  address4Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address4Insurance5IsEscrowed: Checkbox.optional(),
  address4Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address4Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address4Insurance5AgentName: z.string().optional(),
  address4Insurance5AgentEmail: OptionalEmailString,
  address4Insurance5AgentPhone: OptionalPhoneNumber,
  address4Insurance5CompanyName: z.string().optional(),
  address4Insurance5CompanyAddressLine1: AddressLine.optional(),
  address4Insurance5CompanyAddressLine2: AddressLine.optional(),
  address4Insurance5CompanyAddressCity: z.string().optional(),
  address4Insurance5CompanyAddressState: z.string().optional(),
  address4Insurance5CompanyAddressZip: z.string().optional(),
  address4Insurance5PolicyNumber: z.string().optional(),
  address4Insurance5PolicyStart: DateString.optional(),
  address4Insurance5PolicyEnd: DateString.optional(),
  address4Insurance5ForcedPlacedFlag: Checkbox.optional(),

  address4Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address4Insurance6IsEscrowed: Checkbox.optional(),
  address4Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address4Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address4Insurance6AgentName: z.string().optional(),
  address4Insurance6AgentEmail: OptionalEmailString,
  address4Insurance6AgentPhone: OptionalPhoneNumber,
  address4Insurance6CompanyName: z.string().optional(),
  address4Insurance6CompanyAddressLine1: AddressLine.optional(),
  address4Insurance6CompanyAddressLine2: AddressLine.optional(),
  address4Insurance6CompanyAddressCity: z.string().optional(),
  address4Insurance6CompanyAddressState: z.string().optional(),
  address4Insurance6CompanyAddressZip: z.string().optional(),
  address4Insurance6PolicyNumber: z.string().optional(),
  address4Insurance6PolicyStart: DateString.optional(),
  address4Insurance6PolicyEnd: DateString.optional(),
  address4Insurance6ForcedPlacedFlag: Checkbox.optional(),

  // ADDRESS 5
  address5Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address5Insurance1IsEscrowed: Checkbox.optional(),
  address5Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address5Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address5Insurance1AgentName: z.string().optional(),
  address5Insurance1AgentEmail: OptionalEmailString,
  address5Insurance1AgentPhone: OptionalPhoneNumber,
  address5Insurance1CompanyName: z.string().optional(),
  address5Insurance1CompanyAddressLine1: AddressLine.optional(),
  address5Insurance1CompanyAddressLine2: AddressLine.optional(),
  address5Insurance1CompanyAddressCity: z.string().optional(),
  address5Insurance1CompanyAddressState: z.string().optional(),
  address5Insurance1CompanyAddressZip: z.string().optional(),
  address5Insurance1PolicyNumber: z.string().optional(),
  address5Insurance1PolicyStart: DateString.optional(),
  address5Insurance1PolicyEnd: DateString.optional(),
  address5Insurance1ForcedPlacedFlag: Checkbox.optional(),

  address5Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address5Insurance2IsEscrowed: Checkbox.optional(),
  address5Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address5Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address5Insurance2AgentName: z.string().optional(),
  address5Insurance2AgentEmail: OptionalEmailString,
  address5Insurance2AgentPhone: OptionalPhoneNumber,
  address5Insurance2CompanyName: z.string().optional(),
  address5Insurance2CompanyAddressLine1: AddressLine.optional(),
  address5Insurance2CompanyAddressLine2: AddressLine.optional(),
  address5Insurance2CompanyAddressCity: z.string().optional(),
  address5Insurance2CompanyAddressState: z.string().optional(),
  address5Insurance2CompanyAddressZip: z.string().optional(),
  address5Insurance2PolicyNumber: z.string().optional(),
  address5Insurance2PolicyStart: DateString.optional(),
  address5Insurance2PolicyEnd: DateString.optional(),
  address5Insurance2ForcedPlacedFlag: Checkbox.optional(),

  address5Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address5Insurance3IsEscrowed: Checkbox.optional(),
  address5Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address5Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address5Insurance3AgentName: z.string().optional(),
  address5Insurance3AgentEmail: OptionalEmailString,
  address5Insurance3AgentPhone: OptionalPhoneNumber,
  address5Insurance3CompanyName: z.string().optional(),
  address5Insurance3CompanyAddressLine1: AddressLine.optional(),
  address5Insurance3CompanyAddressLine2: AddressLine.optional(),
  address5Insurance3CompanyAddressCity: z.string().optional(),
  address5Insurance3CompanyAddressState: z.string().optional(),
  address5Insurance3CompanyAddressZip: z.string().optional(),
  address5Insurance3PolicyNumber: z.string().optional(),
  address5Insurance3PolicyStart: DateString.optional(),
  address5Insurance3PolicyEnd: DateString.optional(),
  address5Insurance3ForcedPlacedFlag: Checkbox.optional(),

  address5Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address5Insurance4IsEscrowed: Checkbox.optional(),
  address5Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address5Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address5Insurance4AgentName: z.string().optional(),
  address5Insurance4AgentEmail: OptionalEmailString,
  address5Insurance4AgentPhone: OptionalPhoneNumber,
  address5Insurance4CompanyName: z.string().optional(),
  address5Insurance4CompanyAddressLine1: AddressLine.optional(),
  address5Insurance4CompanyAddressLine2: AddressLine.optional(),
  address5Insurance4CompanyAddressCity: z.string().optional(),
  address5Insurance4CompanyAddressState: z.string().optional(),
  address5Insurance4CompanyAddressZip: z.string().optional(),
  address5Insurance4PolicyNumber: z.string().optional(),
  address5Insurance4PolicyStart: DateString.optional(),
  address5Insurance4PolicyEnd: DateString.optional(),
  address5Insurance4ForcedPlacedFlag: Checkbox.optional(),

  address5Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address5Insurance5IsEscrowed: Checkbox.optional(),
  address5Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address5Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address5Insurance5AgentName: z.string().optional(),
  address5Insurance5AgentEmail: OptionalEmailString,
  address5Insurance5AgentPhone: OptionalPhoneNumber,
  address5Insurance5CompanyName: z.string().optional(),
  address5Insurance5CompanyAddressLine1: AddressLine.optional(),
  address5Insurance5CompanyAddressLine2: AddressLine.optional(),
  address5Insurance5CompanyAddressCity: z.string().optional(),
  address5Insurance5CompanyAddressState: z.string().optional(),
  address5Insurance5CompanyAddressZip: z.string().optional(),
  address5Insurance5PolicyNumber: z.string().optional(),
  address5Insurance5PolicyStart: DateString.optional(),
  address5Insurance5PolicyEnd: DateString.optional(),
  address5Insurance5ForcedPlacedFlag: Checkbox.optional(),

  address5Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address5Insurance6IsEscrowed: Checkbox.optional(),
  address5Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address5Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address5Insurance6AgentName: z.string().optional(),
  address5Insurance6AgentEmail: OptionalEmailString,
  address5Insurance6AgentPhone: OptionalPhoneNumber,
  address5Insurance6CompanyName: z.string().optional(),
  address5Insurance6CompanyAddressLine1: AddressLine.optional(),
  address5Insurance6CompanyAddressLine2: AddressLine.optional(),
  address5Insurance6CompanyAddressCity: z.string().optional(),
  address5Insurance6CompanyAddressState: z.string().optional(),
  address5Insurance6CompanyAddressZip: z.string().optional(),
  address5Insurance6PolicyNumber: z.string().optional(),
  address5Insurance6PolicyStart: DateString.optional(),
  address5Insurance6PolicyEnd: DateString.optional(),
  address5Insurance6ForcedPlacedFlag: Checkbox.optional(),

  // ADDRESS 6
  address6Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address6Insurance1IsEscrowed: Checkbox.optional(),
  address6Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address6Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address6Insurance1AgentName: z.string().optional(),
  address6Insurance1AgentEmail: OptionalEmailString,
  address6Insurance1AgentPhone: OptionalPhoneNumber,
  address6Insurance1CompanyName: z.string().optional(),
  address6Insurance1CompanyAddressLine1: AddressLine.optional(),
  address6Insurance1CompanyAddressLine2: AddressLine.optional(),
  address6Insurance1CompanyAddressCity: z.string().optional(),
  address6Insurance1CompanyAddressState: z.string().optional(),
  address6Insurance1CompanyAddressZip: z.string().optional(),
  address6Insurance1PolicyNumber: z.string().optional(),
  address6Insurance1PolicyStart: DateString.optional(),
  address6Insurance1PolicyEnd: DateString.optional(),
  address6Insurance1ForcedPlacedFlag: Checkbox.optional(),

  address6Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address6Insurance2IsEscrowed: Checkbox.optional(),
  address6Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address6Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address6Insurance2AgentName: z.string().optional(),
  address6Insurance2AgentEmail: OptionalEmailString,
  address6Insurance2AgentPhone: OptionalPhoneNumber,
  address6Insurance2CompanyName: z.string().optional(),
  address6Insurance2CompanyAddressLine1: AddressLine.optional(),
  address6Insurance2CompanyAddressLine2: AddressLine.optional(),
  address6Insurance2CompanyAddressCity: z.string().optional(),
  address6Insurance2CompanyAddressState: z.string().optional(),
  address6Insurance2CompanyAddressZip: z.string().optional(),
  address6Insurance2PolicyNumber: z.string().optional(),
  address6Insurance2PolicyStart: DateString.optional(),
  address6Insurance2PolicyEnd: DateString.optional(),
  address6Insurance2ForcedPlacedFlag: Checkbox.optional(),

  address6Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address6Insurance3IsEscrowed: Checkbox.optional(),
  address6Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address6Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address6Insurance3AgentName: z.string().optional(),
  address6Insurance3AgentEmail: OptionalEmailString,
  address6Insurance3AgentPhone: OptionalPhoneNumber,
  address6Insurance3CompanyName: z.string().optional(),
  address6Insurance3CompanyAddressLine1: AddressLine.optional(),
  address6Insurance3CompanyAddressLine2: AddressLine.optional(),
  address6Insurance3CompanyAddressCity: z.string().optional(),
  address6Insurance3CompanyAddressState: z.string().optional(),
  address6Insurance3CompanyAddressZip: z.string().optional(),
  address6Insurance3PolicyNumber: z.string().optional(),
  address6Insurance3PolicyStart: DateString.optional(),
  address6Insurance3PolicyEnd: DateString.optional(),
  address6Insurance3ForcedPlacedFlag: Checkbox.optional(),

  address6Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address6Insurance4IsEscrowed: Checkbox.optional(),
  address6Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address6Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address6Insurance4AgentName: z.string().optional(),
  address6Insurance4AgentEmail: OptionalEmailString,
  address6Insurance4AgentPhone: OptionalPhoneNumber,
  address6Insurance4CompanyName: z.string().optional(),
  address6Insurance4CompanyAddressLine1: AddressLine.optional(),
  address6Insurance4CompanyAddressLine2: AddressLine.optional(),
  address6Insurance4CompanyAddressCity: z.string().optional(),
  address6Insurance4CompanyAddressState: z.string().optional(),
  address6Insurance4CompanyAddressZip: z.string().optional(),
  address6Insurance4PolicyNumber: z.string().optional(),
  address6Insurance4PolicyStart: DateString.optional(),
  address6Insurance4PolicyEnd: DateString.optional(),
  address6Insurance4ForcedPlacedFlag: Checkbox.optional(),

  address6Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address6Insurance5IsEscrowed: Checkbox.optional(),
  address6Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address6Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address6Insurance5AgentName: z.string().optional(),
  address6Insurance5AgentEmail: OptionalEmailString,
  address6Insurance5AgentPhone: OptionalPhoneNumber,
  address6Insurance5CompanyName: z.string().optional(),
  address6Insurance5CompanyAddressLine1: AddressLine.optional(),
  address6Insurance5CompanyAddressLine2: AddressLine.optional(),
  address6Insurance5CompanyAddressCity: z.string().optional(),
  address6Insurance5CompanyAddressState: z.string().optional(),
  address6Insurance5CompanyAddressZip: z.string().optional(),
  address6Insurance5PolicyNumber: z.string().optional(),
  address6Insurance5PolicyStart: DateString.optional(),
  address6Insurance5PolicyEnd: DateString.optional(),
  address6Insurance5ForcedPlacedFlag: Checkbox.optional(),

  address6Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address6Insurance6IsEscrowed: Checkbox.optional(),
  address6Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address6Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address6Insurance6AgentName: z.string().optional(),
  address6Insurance6AgentEmail: OptionalEmailString,
  address6Insurance6AgentPhone: OptionalPhoneNumber,
  address6Insurance6CompanyName: z.string().optional(),
  address6Insurance6CompanyAddressLine1: AddressLine.optional(),
  address6Insurance6CompanyAddressLine2: AddressLine.optional(),
  address6Insurance6CompanyAddressCity: z.string().optional(),
  address6Insurance6CompanyAddressState: z.string().optional(),
  address6Insurance6CompanyAddressZip: z.string().optional(),
  address6Insurance6PolicyNumber: z.string().optional(),
  address6Insurance6PolicyStart: DateString.optional(),
  address6Insurance6PolicyEnd: DateString.optional(),
  address6Insurance6ForcedPlacedFlag: Checkbox.optional(),

  // ADDRESS 7
  address7Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address7Insurance1IsEscrowed: Checkbox.optional(),
  address7Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address7Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address7Insurance1AgentName: z.string().optional(),
  address7Insurance1AgentEmail: OptionalEmailString,
  address7Insurance1AgentPhone: OptionalPhoneNumber,
  address7Insurance1CompanyName: z.string().optional(),
  address7Insurance1CompanyAddressLine1: AddressLine.optional(),
  address7Insurance1CompanyAddressLine2: AddressLine.optional(),
  address7Insurance1CompanyAddressCity: z.string().optional(),
  address7Insurance1CompanyAddressState: z.string().optional(),
  address7Insurance1CompanyAddressZip: z.string().optional(),
  address7Insurance1PolicyNumber: z.string().optional(),
  address7Insurance1PolicyStart: DateString.optional(),
  address7Insurance1PolicyEnd: DateString.optional(),
  address7Insurance1ForcedPlacedFlag: Checkbox.optional(),

  address7Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address7Insurance2IsEscrowed: Checkbox.optional(),
  address7Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address7Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address7Insurance2AgentName: z.string().optional(),
  address7Insurance2AgentEmail: OptionalEmailString,
  address7Insurance2AgentPhone: OptionalPhoneNumber,
  address7Insurance2CompanyName: z.string().optional(),
  address7Insurance2CompanyAddressLine1: AddressLine.optional(),
  address7Insurance2CompanyAddressLine2: AddressLine.optional(),
  address7Insurance2CompanyAddressCity: z.string().optional(),
  address7Insurance2CompanyAddressState: z.string().optional(),
  address7Insurance2CompanyAddressZip: z.string().optional(),
  address7Insurance2PolicyNumber: z.string().optional(),
  address7Insurance2PolicyStart: DateString.optional(),
  address7Insurance2PolicyEnd: DateString.optional(),
  address7Insurance2ForcedPlacedFlag: Checkbox.optional(),

  address7Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address7Insurance3IsEscrowed: Checkbox.optional(),
  address7Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address7Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address7Insurance3AgentName: z.string().optional(),
  address7Insurance3AgentEmail: OptionalEmailString,
  address7Insurance3AgentPhone: OptionalPhoneNumber,
  address7Insurance3CompanyName: z.string().optional(),
  address7Insurance3CompanyAddressLine1: AddressLine.optional(),
  address7Insurance3CompanyAddressLine2: AddressLine.optional(),
  address7Insurance3CompanyAddressCity: z.string().optional(),
  address7Insurance3CompanyAddressState: z.string().optional(),
  address7Insurance3CompanyAddressZip: z.string().optional(),
  address7Insurance3PolicyNumber: z.string().optional(),
  address7Insurance3PolicyStart: DateString.optional(),
  address7Insurance3PolicyEnd: DateString.optional(),
  address7Insurance3ForcedPlacedFlag: Checkbox.optional(),

  address7Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address7Insurance4IsEscrowed: Checkbox.optional(),
  address7Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address7Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address7Insurance4AgentName: z.string().optional(),
  address7Insurance4AgentEmail: OptionalEmailString,
  address7Insurance4AgentPhone: OptionalPhoneNumber,
  address7Insurance4CompanyName: z.string().optional(),
  address7Insurance4CompanyAddressLine1: AddressLine.optional(),
  address7Insurance4CompanyAddressLine2: AddressLine.optional(),
  address7Insurance4CompanyAddressCity: z.string().optional(),
  address7Insurance4CompanyAddressState: z.string().optional(),
  address7Insurance4CompanyAddressZip: z.string().optional(),
  address7Insurance4PolicyNumber: z.string().optional(),
  address7Insurance4PolicyStart: DateString.optional(),
  address7Insurance4PolicyEnd: DateString.optional(),
  address7Insurance4ForcedPlacedFlag: Checkbox.optional(),

  address7Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address7Insurance5IsEscrowed: Checkbox.optional(),
  address7Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address7Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address7Insurance5AgentName: z.string().optional(),
  address7Insurance5AgentEmail: OptionalEmailString,
  address7Insurance5AgentPhone: OptionalPhoneNumber,
  address7Insurance5CompanyName: z.string().optional(),
  address7Insurance5CompanyAddressLine1: AddressLine.optional(),
  address7Insurance5CompanyAddressLine2: AddressLine.optional(),
  address7Insurance5CompanyAddressCity: z.string().optional(),
  address7Insurance5CompanyAddressState: z.string().optional(),
  address7Insurance5CompanyAddressZip: z.string().optional(),
  address7Insurance5PolicyNumber: z.string().optional(),
  address7Insurance5PolicyStart: DateString.optional(),
  address7Insurance5PolicyEnd: DateString.optional(),
  address7Insurance5ForcedPlacedFlag: Checkbox.optional(),

  address7Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address7Insurance6IsEscrowed: Checkbox.optional(),
  address7Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address7Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address7Insurance6AgentName: z.string().optional(),
  address7Insurance6AgentEmail: OptionalEmailString,
  address7Insurance6AgentPhone: OptionalPhoneNumber,
  address7Insurance6CompanyName: z.string().optional(),
  address7Insurance6CompanyAddressLine1: AddressLine.optional(),
  address7Insurance6CompanyAddressLine2: AddressLine.optional(),
  address7Insurance6CompanyAddressCity: z.string().optional(),
  address7Insurance6CompanyAddressState: z.string().optional(),
  address7Insurance6CompanyAddressZip: z.string().optional(),
  address7Insurance6PolicyNumber: z.string().optional(),
  address7Insurance6PolicyStart: DateString.optional(),
  address7Insurance6PolicyEnd: DateString.optional(),
  address7Insurance6ForcedPlacedFlag: Checkbox.optional(),

  // ADDRESS 8
  address8Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address8Insurance1IsEscrowed: Checkbox.optional(),
  address8Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address8Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address8Insurance1AgentName: z.string().optional(),
  address8Insurance1AgentEmail: OptionalEmailString,
  address8Insurance1AgentPhone: OptionalPhoneNumber,
  address8Insurance1CompanyName: z.string().optional(),
  address8Insurance1CompanyAddressLine1: AddressLine.optional(),
  address8Insurance1CompanyAddressLine2: AddressLine.optional(),
  address8Insurance1CompanyAddressCity: z.string().optional(),
  address8Insurance1CompanyAddressState: z.string().optional(),
  address8Insurance1CompanyAddressZip: z.string().optional(),
  address8Insurance1PolicyNumber: z.string().optional(),
  address8Insurance1PolicyStart: DateString.optional(),
  address8Insurance1PolicyEnd: DateString.optional(),
  address8Insurance1ForcedPlacedFlag: Checkbox.optional(),

  address8Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address8Insurance2IsEscrowed: Checkbox.optional(),
  address8Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address8Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address8Insurance2AgentName: z.string().optional(),
  address8Insurance2AgentEmail: OptionalEmailString,
  address8Insurance2AgentPhone: OptionalPhoneNumber,
  address8Insurance2CompanyName: z.string().optional(),
  address8Insurance2CompanyAddressLine1: AddressLine.optional(),
  address8Insurance2CompanyAddressLine2: AddressLine.optional(),
  address8Insurance2CompanyAddressCity: z.string().optional(),
  address8Insurance2CompanyAddressState: z.string().optional(),
  address8Insurance2CompanyAddressZip: z.string().optional(),
  address8Insurance2PolicyNumber: z.string().optional(),
  address8Insurance2PolicyStart: DateString.optional(),
  address8Insurance2PolicyEnd: DateString.optional(),
  address8Insurance2ForcedPlacedFlag: Checkbox.optional(),

  address8Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address8Insurance3IsEscrowed: Checkbox.optional(),
  address8Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address8Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address8Insurance3AgentName: z.string().optional(),
  address8Insurance3AgentEmail: OptionalEmailString,
  address8Insurance3AgentPhone: OptionalPhoneNumber,
  address8Insurance3CompanyName: z.string().optional(),
  address8Insurance3CompanyAddressLine1: AddressLine.optional(),
  address8Insurance3CompanyAddressLine2: AddressLine.optional(),
  address8Insurance3CompanyAddressCity: z.string().optional(),
  address8Insurance3CompanyAddressState: z.string().optional(),
  address8Insurance3CompanyAddressZip: z.string().optional(),
  address8Insurance3PolicyNumber: z.string().optional(),
  address8Insurance3PolicyStart: DateString.optional(),
  address8Insurance3PolicyEnd: DateString.optional(),
  address8Insurance3ForcedPlacedFlag: Checkbox.optional(),

  address8Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address8Insurance4IsEscrowed: Checkbox.optional(),
  address8Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address8Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address8Insurance4AgentName: z.string().optional(),
  address8Insurance4AgentEmail: OptionalEmailString,
  address8Insurance4AgentPhone: OptionalPhoneNumber,
  address8Insurance4CompanyName: z.string().optional(),
  address8Insurance4CompanyAddressLine1: AddressLine.optional(),
  address8Insurance4CompanyAddressLine2: AddressLine.optional(),
  address8Insurance4CompanyAddressCity: z.string().optional(),
  address8Insurance4CompanyAddressState: z.string().optional(),
  address8Insurance4CompanyAddressZip: z.string().optional(),
  address8Insurance4PolicyNumber: z.string().optional(),
  address8Insurance4PolicyStart: DateString.optional(),
  address8Insurance4PolicyEnd: DateString.optional(),
  address8Insurance4ForcedPlacedFlag: Checkbox.optional(),

  address8Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address8Insurance5IsEscrowed: Checkbox.optional(),
  address8Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address8Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address8Insurance5AgentName: z.string().optional(),
  address8Insurance5AgentEmail: OptionalEmailString,
  address8Insurance5AgentPhone: OptionalPhoneNumber,
  address8Insurance5CompanyName: z.string().optional(),
  address8Insurance5CompanyAddressLine1: AddressLine.optional(),
  address8Insurance5CompanyAddressLine2: AddressLine.optional(),
  address8Insurance5CompanyAddressCity: z.string().optional(),
  address8Insurance5CompanyAddressState: z.string().optional(),
  address8Insurance5CompanyAddressZip: z.string().optional(),
  address8Insurance5PolicyNumber: z.string().optional(),
  address8Insurance5PolicyStart: DateString.optional(),
  address8Insurance5PolicyEnd: DateString.optional(),
  address8Insurance5ForcedPlacedFlag: Checkbox.optional(),

  address8Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address8Insurance6IsEscrowed: Checkbox.optional(),
  address8Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address8Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address8Insurance6AgentName: z.string().optional(),
  address8Insurance6AgentEmail: OptionalEmailString,
  address8Insurance6AgentPhone: OptionalPhoneNumber,
  address8Insurance6CompanyName: z.string().optional(),
  address8Insurance6CompanyAddressLine1: AddressLine.optional(),
  address8Insurance6CompanyAddressLine2: AddressLine.optional(),
  address8Insurance6CompanyAddressCity: z.string().optional(),
  address8Insurance6CompanyAddressState: z.string().optional(),
  address8Insurance6CompanyAddressZip: z.string().optional(),
  address8Insurance6PolicyNumber: z.string().optional(),
  address8Insurance6PolicyStart: DateString.optional(),
  address8Insurance6PolicyEnd: DateString.optional(),
  address8Insurance6ForcedPlacedFlag: Checkbox.optional(),

  // ADDRESS 9
  address9Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address9Insurance1IsEscrowed: Checkbox.optional(),
  address9Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address9Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address9Insurance1AgentName: z.string().optional(),
  address9Insurance1AgentEmail: OptionalEmailString,
  address9Insurance1AgentPhone: OptionalPhoneNumber,
  address9Insurance1CompanyName: z.string().optional(),
  address9Insurance1CompanyAddressLine1: AddressLine.optional(),
  address9Insurance1CompanyAddressLine2: AddressLine.optional(),
  address9Insurance1CompanyAddressCity: z.string().optional(),
  address9Insurance1CompanyAddressState: z.string().optional(),
  address9Insurance1CompanyAddressZip: z.string().optional(),
  address9Insurance1PolicyNumber: z.string().optional(),
  address9Insurance1PolicyStart: DateString.optional(),
  address9Insurance1PolicyEnd: DateString.optional(),
  address9Insurance1ForcedPlacedFlag: Checkbox.optional(),

  address9Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address9Insurance2IsEscrowed: Checkbox.optional(),
  address9Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address9Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address9Insurance2AgentName: z.string().optional(),
  address9Insurance2AgentEmail: OptionalEmailString,
  address9Insurance2AgentPhone: OptionalPhoneNumber,
  address9Insurance2CompanyName: z.string().optional(),
  address9Insurance2CompanyAddressLine1: AddressLine.optional(),
  address9Insurance2CompanyAddressLine2: AddressLine.optional(),
  address9Insurance2CompanyAddressCity: z.string().optional(),
  address9Insurance2CompanyAddressState: z.string().optional(),
  address9Insurance2CompanyAddressZip: z.string().optional(),
  address9Insurance2PolicyNumber: z.string().optional(),
  address9Insurance2PolicyStart: DateString.optional(),
  address9Insurance2PolicyEnd: DateString.optional(),
  address9Insurance2ForcedPlacedFlag: Checkbox.optional(),

  address9Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address9Insurance3IsEscrowed: Checkbox.optional(),
  address9Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address9Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address9Insurance3AgentName: z.string().optional(),
  address9Insurance3AgentEmail: OptionalEmailString,
  address9Insurance3AgentPhone: OptionalPhoneNumber,
  address9Insurance3CompanyName: z.string().optional(),
  address9Insurance3CompanyAddressLine1: AddressLine.optional(),
  address9Insurance3CompanyAddressLine2: AddressLine.optional(),
  address9Insurance3CompanyAddressCity: z.string().optional(),
  address9Insurance3CompanyAddressState: z.string().optional(),
  address9Insurance3CompanyAddressZip: z.string().optional(),
  address9Insurance3PolicyNumber: z.string().optional(),
  address9Insurance3PolicyStart: DateString.optional(),
  address9Insurance3PolicyEnd: DateString.optional(),
  address9Insurance3ForcedPlacedFlag: Checkbox.optional(),

  address9Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address9Insurance4IsEscrowed: Checkbox.optional(),
  address9Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address9Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address9Insurance4AgentName: z.string().optional(),
  address9Insurance4AgentEmail: OptionalEmailString,
  address9Insurance4AgentPhone: OptionalPhoneNumber,
  address9Insurance4CompanyName: z.string().optional(),
  address9Insurance4CompanyAddressLine1: AddressLine.optional(),
  address9Insurance4CompanyAddressLine2: AddressLine.optional(),
  address9Insurance4CompanyAddressCity: z.string().optional(),
  address9Insurance4CompanyAddressState: z.string().optional(),
  address9Insurance4CompanyAddressZip: z.string().optional(),
  address9Insurance4PolicyNumber: z.string().optional(),
  address9Insurance4PolicyStart: DateString.optional(),
  address9Insurance4PolicyEnd: DateString.optional(),
  address9Insurance4ForcedPlacedFlag: Checkbox.optional(),

  address9Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address9Insurance5IsEscrowed: Checkbox.optional(),
  address9Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address9Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address9Insurance5AgentName: z.string().optional(),
  address9Insurance5AgentEmail: OptionalEmailString,
  address9Insurance5AgentPhone: OptionalPhoneNumber,
  address9Insurance5CompanyName: z.string().optional(),
  address9Insurance5CompanyAddressLine1: AddressLine.optional(),
  address9Insurance5CompanyAddressLine2: AddressLine.optional(),
  address9Insurance5CompanyAddressCity: z.string().optional(),
  address9Insurance5CompanyAddressState: z.string().optional(),
  address9Insurance5CompanyAddressZip: z.string().optional(),
  address9Insurance5PolicyNumber: z.string().optional(),
  address9Insurance5PolicyStart: DateString.optional(),
  address9Insurance5PolicyEnd: DateString.optional(),
  address9Insurance5ForcedPlacedFlag: Checkbox.optional(),

  address9Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address9Insurance6IsEscrowed: Checkbox.optional(),
  address9Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address9Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address9Insurance6AgentName: z.string().optional(),
  address9Insurance6AgentEmail: OptionalEmailString,
  address9Insurance6AgentPhone: OptionalPhoneNumber,
  address9Insurance6CompanyName: z.string().optional(),
  address9Insurance6CompanyAddressLine1: AddressLine.optional(),
  address9Insurance6CompanyAddressLine2: AddressLine.optional(),
  address9Insurance6CompanyAddressCity: z.string().optional(),
  address9Insurance6CompanyAddressState: z.string().optional(),
  address9Insurance6CompanyAddressZip: z.string().optional(),
  address9Insurance6PolicyNumber: z.string().optional(),
  address9Insurance6PolicyStart: DateString.optional(),
  address9Insurance6PolicyEnd: DateString.optional(),
  address9Insurance6ForcedPlacedFlag: Checkbox.optional(),

  // ADDRESS 10
  address10Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address10Insurance1IsEscrowed: Checkbox.optional(),
  address10Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address10Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address10Insurance1AgentName: z.string().optional(),
  address10Insurance1AgentEmail: OptionalEmailString,
  address10Insurance1AgentPhone: OptionalPhoneNumber,
  address10Insurance1CompanyName: z.string().optional(),
  address10Insurance1CompanyAddressLine1: AddressLine.optional(),
  address10Insurance1CompanyAddressLine2: AddressLine.optional(),
  address10Insurance1CompanyAddressCity: z.string().optional(),
  address10Insurance1CompanyAddressState: z.string().optional(),
  address10Insurance1CompanyAddressZip: z.string().optional(),
  address10Insurance1PolicyNumber: z.string().optional(),
  address10Insurance1PolicyStart: DateString.optional(),
  address10Insurance1PolicyEnd: DateString.optional(),
  address10Insurance1ForcedPlacedFlag: Checkbox.optional(),

  address10Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address10Insurance2IsEscrowed: Checkbox.optional(),
  address10Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address10Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address10Insurance2AgentName: z.string().optional(),
  address10Insurance2AgentEmail: OptionalEmailString,
  address10Insurance2AgentPhone: OptionalPhoneNumber,
  address10Insurance2CompanyName: z.string().optional(),
  address10Insurance2CompanyAddressLine1: AddressLine.optional(),
  address10Insurance2CompanyAddressLine2: AddressLine.optional(),
  address10Insurance2CompanyAddressCity: z.string().optional(),
  address10Insurance2CompanyAddressState: z.string().optional(),
  address10Insurance2CompanyAddressZip: z.string().optional(),
  address10Insurance2PolicyNumber: z.string().optional(),
  address10Insurance2PolicyStart: DateString.optional(),
  address10Insurance2PolicyEnd: DateString.optional(),
  address10Insurance2ForcedPlacedFlag: Checkbox.optional(),

  address10Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address10Insurance3IsEscrowed: Checkbox.optional(),
  address10Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address10Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address10Insurance3AgentName: z.string().optional(),
  address10Insurance3AgentEmail: OptionalEmailString,
  address10Insurance3AgentPhone: OptionalPhoneNumber,
  address10Insurance3CompanyName: z.string().optional(),
  address10Insurance3CompanyAddressLine1: AddressLine.optional(),
  address10Insurance3CompanyAddressLine2: AddressLine.optional(),
  address10Insurance3CompanyAddressCity: z.string().optional(),
  address10Insurance3CompanyAddressState: z.string().optional(),
  address10Insurance3CompanyAddressZip: z.string().optional(),
  address10Insurance3PolicyNumber: z.string().optional(),
  address10Insurance3PolicyStart: DateString.optional(),
  address10Insurance3PolicyEnd: DateString.optional(),
  address10Insurance3ForcedPlacedFlag: Checkbox.optional(),

  address10Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address10Insurance4IsEscrowed: Checkbox.optional(),
  address10Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address10Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address10Insurance4AgentName: z.string().optional(),
  address10Insurance4AgentEmail: OptionalEmailString,
  address10Insurance4AgentPhone: OptionalPhoneNumber,
  address10Insurance4CompanyName: z.string().optional(),
  address10Insurance4CompanyAddressLine1: AddressLine.optional(),
  address10Insurance4CompanyAddressLine2: AddressLine.optional(),
  address10Insurance4CompanyAddressCity: z.string().optional(),
  address10Insurance4CompanyAddressState: z.string().optional(),
  address10Insurance4CompanyAddressZip: z.string().optional(),
  address10Insurance4PolicyNumber: z.string().optional(),
  address10Insurance4PolicyStart: DateString.optional(),
  address10Insurance4PolicyEnd: DateString.optional(),
  address10Insurance4ForcedPlacedFlag: Checkbox.optional(),

  address10Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address10Insurance5IsEscrowed: Checkbox.optional(),
  address10Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address10Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address10Insurance5AgentName: z.string().optional(),
  address10Insurance5AgentEmail: OptionalEmailString,
  address10Insurance5AgentPhone: OptionalPhoneNumber,
  address10Insurance5CompanyName: z.string().optional(),
  address10Insurance5CompanyAddressLine1: AddressLine.optional(),
  address10Insurance5CompanyAddressLine2: AddressLine.optional(),
  address10Insurance5CompanyAddressCity: z.string().optional(),
  address10Insurance5CompanyAddressState: z.string().optional(),
  address10Insurance5CompanyAddressZip: z.string().optional(),
  address10Insurance5PolicyNumber: z.string().optional(),
  address10Insurance5PolicyStart: DateString.optional(),
  address10Insurance5PolicyEnd: DateString.optional(),
  address10Insurance5ForcedPlacedFlag: Checkbox.optional(),

  address10Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address10Insurance6IsEscrowed: Checkbox.optional(),
  address10Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address10Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address10Insurance6AgentName: z.string().optional(),
  address10Insurance6AgentEmail: OptionalEmailString,
  address10Insurance6AgentPhone: OptionalPhoneNumber,
  address10Insurance6CompanyName: z.string().optional(),
  address10Insurance6CompanyAddressLine1: AddressLine.optional(),
  address10Insurance6CompanyAddressLine2: AddressLine.optional(),
  address10Insurance6CompanyAddressCity: z.string().optional(),
  address10Insurance6CompanyAddressState: z.string().optional(),
  address10Insurance6CompanyAddressZip: z.string().optional(),
  address10Insurance6PolicyNumber: z.string().optional(),
  address10Insurance6PolicyStart: DateString.optional(),
  address10Insurance6PolicyEnd: DateString.optional(),

  address11Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address11Insurance1IsEscrowed: Checkbox.optional(),
  address11Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address11Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address11Insurance1AgentName: z.string().optional(),
  address11Insurance1AgentEmail: OptionalEmailString,
  address11Insurance1AgentPhone: OptionalPhoneNumber,
  address11Insurance1CompanyName: z.string().optional(),
  address11Insurance1CompanyAddressLine1: AddressLine.optional(),
  address11Insurance1CompanyAddressLine2: AddressLine.optional(),
  address11Insurance1CompanyAddressCity: z.string().optional(),
  address11Insurance1CompanyAddressState: z.string().optional(),
  address11Insurance1CompanyAddressZip: z.string().optional(),
  address11Insurance1PolicyNumber: z.string().optional(),
  address11Insurance1PolicyStart: DateString.optional(),
  address11Insurance1PolicyEnd: DateString.optional(),

  address11Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address11Insurance2IsEscrowed: Checkbox.optional(),
  address11Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address11Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address11Insurance2AgentName: z.string().optional(),
  address11Insurance2AgentEmail: OptionalEmailString,
  address11Insurance2AgentPhone: OptionalPhoneNumber,
  address11Insurance2CompanyName: z.string().optional(),
  address11Insurance2CompanyAddressLine1: AddressLine.optional(),
  address11Insurance2CompanyAddressLine2: AddressLine.optional(),
  address11Insurance2CompanyAddressCity: z.string().optional(),
  address11Insurance2CompanyAddressState: z.string().optional(),
  address11Insurance2CompanyAddressZip: z.string().optional(),
  address11Insurance2PolicyNumber: z.string().optional(),
  address11Insurance2PolicyStart: DateString.optional(),
  address11Insurance2PolicyEnd: DateString.optional(),

  address11Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address11Insurance3IsEscrowed: Checkbox.optional(),
  address11Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address11Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address11Insurance3AgentName: z.string().optional(),
  address11Insurance3AgentEmail: OptionalEmailString,
  address11Insurance3AgentPhone: OptionalPhoneNumber,
  address11Insurance3CompanyName: z.string().optional(),
  address11Insurance3CompanyAddressLine1: AddressLine.optional(),
  address11Insurance3CompanyAddressLine2: AddressLine.optional(),
  address11Insurance3CompanyAddressCity: z.string().optional(),
  address11Insurance3CompanyAddressState: z.string().optional(),
  address11Insurance3CompanyAddressZip: z.string().optional(),
  address11Insurance3PolicyNumber: z.string().optional(),
  address11Insurance3PolicyStart: DateString.optional(),
  address11Insurance3PolicyEnd: DateString.optional(),

  address11Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address11Insurance4IsEscrowed: Checkbox.optional(),
  address11Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address11Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address11Insurance4AgentName: z.string().optional(),
  address11Insurance4AgentEmail: OptionalEmailString,
  address11Insurance4AgentPhone: OptionalPhoneNumber,
  address11Insurance4CompanyName: z.string().optional(),
  address11Insurance4CompanyAddressLine1: AddressLine.optional(),
  address11Insurance4CompanyAddressLine2: AddressLine.optional(),
  address11Insurance4CompanyAddressCity: z.string().optional(),
  address11Insurance4CompanyAddressState: z.string().optional(),
  address11Insurance4CompanyAddressZip: z.string().optional(),
  address11Insurance4PolicyNumber: z.string().optional(),
  address11Insurance4PolicyStart: DateString.optional(),
  address11Insurance4PolicyEnd: DateString.optional(),

  address11Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address11Insurance5IsEscrowed: Checkbox.optional(),
  address11Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address11Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address11Insurance5AgentName: z.string().optional(),
  address11Insurance5AgentEmail: OptionalEmailString,
  address11Insurance5AgentPhone: OptionalPhoneNumber,
  address11Insurance5CompanyName: z.string().optional(),
  address11Insurance5CompanyAddressLine1: AddressLine.optional(),
  address11Insurance5CompanyAddressLine2: AddressLine.optional(),
  address11Insurance5CompanyAddressCity: z.string().optional(),
  address11Insurance5CompanyAddressState: z.string().optional(),
  address11Insurance5CompanyAddressZip: z.string().optional(),
  address11Insurance5PolicyNumber: z.string().optional(),
  address11Insurance5PolicyStart: DateString.optional(),
  address11Insurance5PolicyEnd: DateString.optional(),

  address11Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address11Insurance6IsEscrowed: Checkbox.optional(),
  address11Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address11Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address11Insurance6AgentName: z.string().optional(),
  address11Insurance6AgentEmail: OptionalEmailString,
  address11Insurance6AgentPhone: OptionalPhoneNumber,
  address11Insurance6CompanyName: z.string().optional(),
  address11Insurance6CompanyAddressLine1: AddressLine.optional(),
  address11Insurance6CompanyAddressLine2: AddressLine.optional(),
  address11Insurance6CompanyAddressCity: z.string().optional(),
  address11Insurance6CompanyAddressState: z.string().optional(),
  address11Insurance6CompanyAddressZip: z.string().optional(),
  address11Insurance6PolicyNumber: z.string().optional(),
  address11Insurance6PolicyStart: DateString.optional(),
  address11Insurance6PolicyEnd: DateString.optional(),

  address12Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address12Insurance1IsEscrowed: Checkbox.optional(),
  address12Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address12Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address12Insurance1AgentName: z.string().optional(),
  address12Insurance1AgentEmail: OptionalEmailString,
  address12Insurance1AgentPhone: OptionalPhoneNumber,
  address12Insurance1CompanyName: z.string().optional(),
  address12Insurance1CompanyAddressLine1: AddressLine.optional(),
  address12Insurance1CompanyAddressLine2: AddressLine.optional(),
  address12Insurance1CompanyAddressCity: z.string().optional(),
  address12Insurance1CompanyAddressState: z.string().optional(),
  address12Insurance1CompanyAddressZip: z.string().optional(),
  address12Insurance1PolicyNumber: z.string().optional(),
  address12Insurance1PolicyStart: DateString.optional(),
  address12Insurance1PolicyEnd: DateString.optional(),

  address12Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address12Insurance2IsEscrowed: Checkbox.optional(),
  address12Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address12Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address12Insurance2AgentName: z.string().optional(),
  address12Insurance2AgentEmail: OptionalEmailString,
  address12Insurance2AgentPhone: OptionalPhoneNumber,
  address12Insurance2CompanyName: z.string().optional(),
  address12Insurance2CompanyAddressLine1: AddressLine.optional(),
  address12Insurance2CompanyAddressLine2: AddressLine.optional(),
  address12Insurance2CompanyAddressCity: z.string().optional(),
  address12Insurance2CompanyAddressState: z.string().optional(),
  address12Insurance2CompanyAddressZip: z.string().optional(),
  address12Insurance2PolicyNumber: z.string().optional(),
  address12Insurance2PolicyStart: DateString.optional(),
  address12Insurance2PolicyEnd: DateString.optional(),

  address12Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address12Insurance3IsEscrowed: Checkbox.optional(),
  address12Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address12Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address12Insurance3AgentName: z.string().optional(),
  address12Insurance3AgentEmail: OptionalEmailString,
  address12Insurance3AgentPhone: OptionalPhoneNumber,
  address12Insurance3CompanyName: z.string().optional(),
  address12Insurance3CompanyAddressLine1: AddressLine.optional(),
  address12Insurance3CompanyAddressLine2: AddressLine.optional(),
  address12Insurance3CompanyAddressCity: z.string().optional(),
  address12Insurance3CompanyAddressState: z.string().optional(),
  address12Insurance3CompanyAddressZip: z.string().optional(),
  address12Insurance3PolicyNumber: z.string().optional(),
  address12Insurance3PolicyStart: DateString.optional(),
  address12Insurance3PolicyEnd: DateString.optional(),

  address12Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address12Insurance4IsEscrowed: Checkbox.optional(),
  address12Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address12Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address12Insurance4AgentName: z.string().optional(),
  address12Insurance4AgentEmail: OptionalEmailString,
  address12Insurance4AgentPhone: OptionalPhoneNumber,
  address12Insurance4CompanyName: z.string().optional(),
  address12Insurance4CompanyAddressLine1: AddressLine.optional(),
  address12Insurance4CompanyAddressLine2: AddressLine.optional(),
  address12Insurance4CompanyAddressCity: z.string().optional(),
  address12Insurance4CompanyAddressState: z.string().optional(),
  address12Insurance4CompanyAddressZip: z.string().optional(),
  address12Insurance4PolicyNumber: z.string().optional(),
  address12Insurance4PolicyStart: DateString.optional(),
  address12Insurance4PolicyEnd: DateString.optional(),

  address12Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address12Insurance5IsEscrowed: Checkbox.optional(),
  address12Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address12Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address12Insurance5AgentName: z.string().optional(),
  address12Insurance5AgentEmail: OptionalEmailString,
  address12Insurance5AgentPhone: OptionalPhoneNumber,
  address12Insurance5CompanyName: z.string().optional(),
  address12Insurance5CompanyAddressLine1: AddressLine.optional(),
  address12Insurance5CompanyAddressLine2: AddressLine.optional(),
  address12Insurance5CompanyAddressCity: z.string().optional(),
  address12Insurance5CompanyAddressState: z.string().optional(),
  address12Insurance5CompanyAddressZip: z.string().optional(),
  address12Insurance5PolicyNumber: z.string().optional(),
  address12Insurance5PolicyStart: DateString.optional(),
  address12Insurance5PolicyEnd: DateString.optional(),

  address12Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address12Insurance6IsEscrowed: Checkbox.optional(),
  address12Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address12Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address12Insurance6AgentName: z.string().optional(),
  address12Insurance6AgentEmail: OptionalEmailString,
  address12Insurance6AgentPhone: OptionalPhoneNumber,
  address12Insurance6CompanyName: z.string().optional(),
  address12Insurance6CompanyAddressLine1: AddressLine.optional(),
  address12Insurance6CompanyAddressLine2: AddressLine.optional(),
  address12Insurance6CompanyAddressCity: z.string().optional(),
  address12Insurance6CompanyAddressState: z.string().optional(),
  address12Insurance6CompanyAddressZip: z.string().optional(),
  address12Insurance6PolicyNumber: z.string().optional(),
  address12Insurance6PolicyStart: DateString.optional(),
  address12Insurance6PolicyEnd: DateString.optional(),

  address13Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address13Insurance1IsEscrowed: Checkbox.optional(),
  address13Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address13Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address13Insurance1AgentName: z.string().optional(),
  address13Insurance1AgentEmail: OptionalEmailString,
  address13Insurance1AgentPhone: OptionalPhoneNumber,
  address13Insurance1CompanyName: z.string().optional(),
  address13Insurance1CompanyAddressLine1: AddressLine.optional(),
  address13Insurance1CompanyAddressLine2: AddressLine.optional(),
  address13Insurance1CompanyAddressCity: z.string().optional(),
  address13Insurance1CompanyAddressState: z.string().optional(),
  address13Insurance1CompanyAddressZip: z.string().optional(),
  address13Insurance1PolicyNumber: z.string().optional(),
  address13Insurance1PolicyStart: DateString.optional(),
  address13Insurance1PolicyEnd: DateString.optional(),

  address13Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address13Insurance2IsEscrowed: Checkbox.optional(),
  address13Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address13Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address13Insurance2AgentName: z.string().optional(),
  address13Insurance2AgentEmail: OptionalEmailString,
  address13Insurance2AgentPhone: OptionalPhoneNumber,
  address13Insurance2CompanyName: z.string().optional(),
  address13Insurance2CompanyAddressLine1: AddressLine.optional(),
  address13Insurance2CompanyAddressLine2: AddressLine.optional(),
  address13Insurance2CompanyAddressCity: z.string().optional(),
  address13Insurance2CompanyAddressState: z.string().optional(),
  address13Insurance2CompanyAddressZip: z.string().optional(),
  address13Insurance2PolicyNumber: z.string().optional(),
  address13Insurance2PolicyStart: DateString.optional(),
  address13Insurance2PolicyEnd: DateString.optional(),

  address13Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address13Insurance3IsEscrowed: Checkbox.optional(),
  address13Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address13Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address13Insurance3AgentName: z.string().optional(),
  address13Insurance3AgentEmail: OptionalEmailString,
  address13Insurance3AgentPhone: OptionalPhoneNumber,
  address13Insurance3CompanyName: z.string().optional(),
  address13Insurance3CompanyAddressLine1: AddressLine.optional(),
  address13Insurance3CompanyAddressLine2: AddressLine.optional(),
  address13Insurance3CompanyAddressCity: z.string().optional(),
  address13Insurance3CompanyAddressState: z.string().optional(),
  address13Insurance3CompanyAddressZip: z.string().optional(),
  address13Insurance3PolicyNumber: z.string().optional(),
  address13Insurance3PolicyStart: DateString.optional(),
  address13Insurance3PolicyEnd: DateString.optional(),

  address13Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address13Insurance4IsEscrowed: Checkbox.optional(),
  address13Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address13Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address13Insurance4AgentName: z.string().optional(),
  address13Insurance4AgentEmail: OptionalEmailString,
  address13Insurance4AgentPhone: OptionalPhoneNumber,
  address13Insurance4CompanyName: z.string().optional(),
  address13Insurance4CompanyAddressLine1: AddressLine.optional(),
  address13Insurance4CompanyAddressLine2: AddressLine.optional(),
  address13Insurance4CompanyAddressCity: z.string().optional(),
  address13Insurance4CompanyAddressState: z.string().optional(),
  address13Insurance4CompanyAddressZip: z.string().optional(),
  address13Insurance4PolicyNumber: z.string().optional(),
  address13Insurance4PolicyStart: DateString.optional(),
  address13Insurance4PolicyEnd: DateString.optional(),

  address13Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address13Insurance5IsEscrowed: Checkbox.optional(),
  address13Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address13Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address13Insurance5AgentName: z.string().optional(),
  address13Insurance5AgentEmail: OptionalEmailString,
  address13Insurance5AgentPhone: OptionalPhoneNumber,
  address13Insurance5CompanyName: z.string().optional(),
  address13Insurance5CompanyAddressLine1: AddressLine.optional(),
  address13Insurance5CompanyAddressLine2: AddressLine.optional(),
  address13Insurance5CompanyAddressCity: z.string().optional(),
  address13Insurance5CompanyAddressState: z.string().optional(),
  address13Insurance5CompanyAddressZip: z.string().optional(),
  address13Insurance5PolicyNumber: z.string().optional(),
  address13Insurance5PolicyStart: DateString.optional(),
  address13Insurance5PolicyEnd: DateString.optional(),

  address13Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address13Insurance6IsEscrowed: Checkbox.optional(),
  address13Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address13Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address13Insurance6AgentName: z.string().optional(),
  address13Insurance6AgentEmail: OptionalEmailString,
  address13Insurance6AgentPhone: OptionalPhoneNumber,
  address13Insurance6CompanyName: z.string().optional(),
  address13Insurance6CompanyAddressLine1: AddressLine.optional(),
  address13Insurance6CompanyAddressLine2: AddressLine.optional(),
  address13Insurance6CompanyAddressCity: z.string().optional(),
  address13Insurance6CompanyAddressState: z.string().optional(),
  address13Insurance6CompanyAddressZip: z.string().optional(),
  address13Insurance6PolicyNumber: z.string().optional(),
  address13Insurance6PolicyStart: DateString.optional(),
  address13Insurance6PolicyEnd: DateString.optional(),

  address14Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address14Insurance1IsEscrowed: Checkbox.optional(),
  address14Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address14Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address14Insurance1AgentName: z.string().optional(),
  address14Insurance1AgentEmail: OptionalEmailString,
  address14Insurance1AgentPhone: OptionalPhoneNumber,
  address14Insurance1CompanyName: z.string().optional(),
  address14Insurance1CompanyAddressLine1: AddressLine.optional(),
  address14Insurance1CompanyAddressLine2: AddressLine.optional(),
  address14Insurance1CompanyAddressCity: z.string().optional(),
  address14Insurance1CompanyAddressState: z.string().optional(),
  address14Insurance1CompanyAddressZip: z.string().optional(),
  address14Insurance1PolicyNumber: z.string().optional(),
  address14Insurance1PolicyStart: DateString.optional(),
  address14Insurance1PolicyEnd: DateString.optional(),

  address14Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address14Insurance2IsEscrowed: Checkbox.optional(),
  address14Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address14Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address14Insurance2AgentName: z.string().optional(),
  address14Insurance2AgentEmail: OptionalEmailString,
  address14Insurance2AgentPhone: OptionalPhoneNumber,
  address14Insurance2CompanyName: z.string().optional(),
  address14Insurance2CompanyAddressLine1: AddressLine.optional(),
  address14Insurance2CompanyAddressLine2: AddressLine.optional(),
  address14Insurance2CompanyAddressCity: z.string().optional(),
  address14Insurance2CompanyAddressState: z.string().optional(),
  address14Insurance2CompanyAddressZip: z.string().optional(),
  address14Insurance2PolicyNumber: z.string().optional(),
  address14Insurance2PolicyStart: DateString.optional(),
  address14Insurance2PolicyEnd: DateString.optional(),

  address14Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address14Insurance3IsEscrowed: Checkbox.optional(),
  address14Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address14Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address14Insurance3AgentName: z.string().optional(),
  address14Insurance3AgentEmail: OptionalEmailString,
  address14Insurance3AgentPhone: OptionalPhoneNumber,
  address14Insurance3CompanyName: z.string().optional(),
  address14Insurance3CompanyAddressLine1: AddressLine.optional(),
  address14Insurance3CompanyAddressLine2: AddressLine.optional(),
  address14Insurance3CompanyAddressCity: z.string().optional(),
  address14Insurance3CompanyAddressState: z.string().optional(),
  address14Insurance3CompanyAddressZip: z.string().optional(),
  address14Insurance3PolicyNumber: z.string().optional(),
  address14Insurance3PolicyStart: DateString.optional(),
  address14Insurance3PolicyEnd: DateString.optional(),

  address14Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address14Insurance4IsEscrowed: Checkbox.optional(),
  address14Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address14Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address14Insurance4AgentName: z.string().optional(),
  address14Insurance4AgentEmail: OptionalEmailString,
  address14Insurance4AgentPhone: OptionalPhoneNumber,
  address14Insurance4CompanyName: z.string().optional(),
  address14Insurance4CompanyAddressLine1: AddressLine.optional(),
  address14Insurance4CompanyAddressLine2: AddressLine.optional(),
  address14Insurance4CompanyAddressCity: z.string().optional(),
  address14Insurance4CompanyAddressState: z.string().optional(),
  address14Insurance4CompanyAddressZip: z.string().optional(),
  address14Insurance4PolicyNumber: z.string().optional(),
  address14Insurance4PolicyStart: DateString.optional(),
  address14Insurance4PolicyEnd: DateString.optional(),

  address14Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address14Insurance5IsEscrowed: Checkbox.optional(),
  address14Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address14Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address14Insurance5AgentName: z.string().optional(),
  address14Insurance5AgentEmail: OptionalEmailString,
  address14Insurance5AgentPhone: OptionalPhoneNumber,
  address14Insurance5CompanyName: z.string().optional(),
  address14Insurance5CompanyAddressLine1: AddressLine.optional(),
  address14Insurance5CompanyAddressLine2: AddressLine.optional(),
  address14Insurance5CompanyAddressCity: z.string().optional(),
  address14Insurance5CompanyAddressState: z.string().optional(),
  address14Insurance5CompanyAddressZip: z.string().optional(),
  address14Insurance5PolicyNumber: z.string().optional(),
  address14Insurance5PolicyStart: DateString.optional(),
  address14Insurance5PolicyEnd: DateString.optional(),

  address14Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address14Insurance6IsEscrowed: Checkbox.optional(),
  address14Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address14Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address14Insurance6AgentName: z.string().optional(),
  address14Insurance6AgentEmail: OptionalEmailString,
  address14Insurance6AgentPhone: OptionalPhoneNumber,
  address14Insurance6CompanyName: z.string().optional(),
  address14Insurance6CompanyAddressLine1: AddressLine.optional(),
  address14Insurance6CompanyAddressLine2: AddressLine.optional(),
  address14Insurance6CompanyAddressCity: z.string().optional(),
  address14Insurance6CompanyAddressState: z.string().optional(),
  address14Insurance6CompanyAddressZip: z.string().optional(),
  address14Insurance6PolicyNumber: z.string().optional(),
  address14Insurance6PolicyStart: DateString.optional(),
  address14Insurance6PolicyEnd: DateString.optional(),

  address15Insurance1Type: CoercedEscrowInsuranceType.optional(),
  address15Insurance1IsEscrowed: Checkbox.optional(),
  address15Insurance1Amount: NonNegativeMonetaryValue.optional(),
  address15Insurance1CoverageAmount: NonNegativeMonetaryValue.optional(),
  address15Insurance1AgentName: z.string().optional(),
  address15Insurance1AgentEmail: OptionalEmailString,
  address15Insurance1AgentPhone: OptionalPhoneNumber,
  address15Insurance1CompanyName: z.string().optional(),
  address15Insurance1CompanyAddressLine1: AddressLine.optional(),
  address15Insurance1CompanyAddressLine2: AddressLine.optional(),
  address15Insurance1CompanyAddressCity: z.string().optional(),
  address15Insurance1CompanyAddressState: z.string().optional(),
  address15Insurance1CompanyAddressZip: z.string().optional(),
  address15Insurance1PolicyNumber: z.string().optional(),
  address15Insurance1PolicyStart: DateString.optional(),
  address15Insurance1PolicyEnd: DateString.optional(),

  address15Insurance2Type: CoercedEscrowInsuranceType.optional(),
  address15Insurance2IsEscrowed: Checkbox.optional(),
  address15Insurance2Amount: NonNegativeMonetaryValue.optional(),
  address15Insurance2CoverageAmount: NonNegativeMonetaryValue.optional(),
  address15Insurance2AgentName: z.string().optional(),
  address15Insurance2AgentEmail: OptionalEmailString,
  address15Insurance2AgentPhone: OptionalPhoneNumber,
  address15Insurance2CompanyName: z.string().optional(),
  address15Insurance2CompanyAddressLine1: AddressLine.optional(),
  address15Insurance2CompanyAddressLine2: AddressLine.optional(),
  address15Insurance2CompanyAddressCity: z.string().optional(),
  address15Insurance2CompanyAddressState: z.string().optional(),
  address15Insurance2CompanyAddressZip: z.string().optional(),
  address15Insurance2PolicyNumber: z.string().optional(),
  address15Insurance2PolicyStart: DateString.optional(),
  address15Insurance2PolicyEnd: DateString.optional(),

  address15Insurance3Type: CoercedEscrowInsuranceType.optional(),
  address15Insurance3IsEscrowed: Checkbox.optional(),
  address15Insurance3Amount: NonNegativeMonetaryValue.optional(),
  address15Insurance3CoverageAmount: NonNegativeMonetaryValue.optional(),
  address15Insurance3AgentName: z.string().optional(),
  address15Insurance3AgentEmail: OptionalEmailString,
  address15Insurance3AgentPhone: OptionalPhoneNumber,
  address15Insurance3CompanyName: z.string().optional(),
  address15Insurance3CompanyAddressLine1: AddressLine.optional(),
  address15Insurance3CompanyAddressLine2: AddressLine.optional(),
  address15Insurance3CompanyAddressCity: z.string().optional(),
  address15Insurance3CompanyAddressState: z.string().optional(),
  address15Insurance3CompanyAddressZip: z.string().optional(),
  address15Insurance3PolicyNumber: z.string().optional(),
  address15Insurance3PolicyStart: DateString.optional(),
  address15Insurance3PolicyEnd: DateString.optional(),

  address15Insurance4Type: CoercedEscrowInsuranceType.optional(),
  address15Insurance4IsEscrowed: Checkbox.optional(),
  address15Insurance4Amount: NonNegativeMonetaryValue.optional(),
  address15Insurance4CoverageAmount: NonNegativeMonetaryValue.optional(),
  address15Insurance4AgentName: z.string().optional(),
  address15Insurance4AgentEmail: OptionalEmailString,
  address15Insurance4AgentPhone: OptionalPhoneNumber,
  address15Insurance4CompanyName: z.string().optional(),
  address15Insurance4CompanyAddressLine1: AddressLine.optional(),
  address15Insurance4CompanyAddressLine2: AddressLine.optional(),
  address15Insurance4CompanyAddressCity: z.string().optional(),
  address15Insurance4CompanyAddressState: z.string().optional(),
  address15Insurance4CompanyAddressZip: z.string().optional(),
  address15Insurance4PolicyNumber: z.string().optional(),
  address15Insurance4PolicyStart: DateString.optional(),
  address15Insurance4PolicyEnd: DateString.optional(),

  address15Insurance5Type: CoercedEscrowInsuranceType.optional(),
  address15Insurance5IsEscrowed: Checkbox.optional(),
  address15Insurance5Amount: NonNegativeMonetaryValue.optional(),
  address15Insurance5CoverageAmount: NonNegativeMonetaryValue.optional(),
  address15Insurance5AgentName: z.string().optional(),
  address15Insurance5AgentEmail: OptionalEmailString,
  address15Insurance5AgentPhone: OptionalPhoneNumber,
  address15Insurance5CompanyName: z.string().optional(),
  address15Insurance5CompanyAddressLine1: AddressLine.optional(),
  address15Insurance5CompanyAddressLine2: AddressLine.optional(),
  address15Insurance5CompanyAddressCity: z.string().optional(),
  address15Insurance5CompanyAddressState: z.string().optional(),
  address15Insurance5CompanyAddressZip: z.string().optional(),
  address15Insurance5PolicyNumber: z.string().optional(),
  address15Insurance5PolicyStart: DateString.optional(),
  address15Insurance5PolicyEnd: DateString.optional(),

  address15Insurance6Type: CoercedEscrowInsuranceType.optional(),
  address15Insurance6IsEscrowed: Checkbox.optional(),
  address15Insurance6Amount: NonNegativeMonetaryValue.optional(),
  address15Insurance6CoverageAmount: NonNegativeMonetaryValue.optional(),
  address15Insurance6AgentName: z.string().optional(),
  address15Insurance6AgentEmail: OptionalEmailString,
  address15Insurance6AgentPhone: OptionalPhoneNumber,
  address15Insurance6CompanyName: z.string().optional(),
  address15Insurance6CompanyAddressLine1: AddressLine.optional(),
  address15Insurance6CompanyAddressLine2: AddressLine.optional(),
  address15Insurance6CompanyAddressCity: z.string().optional(),
  address15Insurance6CompanyAddressState: z.string().optional(),
  address15Insurance6CompanyAddressZip: z.string().optional(),
  address15Insurance6PolicyNumber: z.string().optional(),
  address15Insurance6PolicyStart: DateString.optional(),
  address15Insurance6PolicyEnd: DateString.optional(),
  address15Insurance6ForcedPlacedFlag: Checkbox.optional(),
});

export type DeprecatedInsuranceFields = z.infer<typeof DeprecatedInsuranceFields>;
export type DeprecatedMultipleAddressesInsuranceFields = z.infer<typeof DeprecatedMultipleAddressesInsuranceFields>;

export type DeprecatedSingleInsuranceFields = Pick<
  DeprecatedInsuranceFields,
  | 'insurance1Type'
  | 'insurance1IsEscrowed'
  | 'insurance1Amount'
  | 'insurance1CoverageAmount'
  | 'insurance1AgentName'
  | 'insurance1AgentEmail'
  | 'insurance1AgentPhone'
  | 'insurance1CompanyName'
  | 'insurance1CompanyAddressLine1'
  | 'insurance1CompanyAddressLine2'
  | 'insurance1CompanyAddressCity'
  | 'insurance1CompanyAddressState'
  | 'insurance1CompanyAddressZip'
  | 'insurance1PolicyNumber'
  | 'insurance1PolicyStart'
  | 'insurance1PolicyEnd'
  | 'insurance1ForcedPlacedFlag'
>;
